import React from 'react'
import { Box } from 'components/Layout'
import Card from 'components/Card'

interface Props {
  topContent: React.ReactElement
}

const Details: React.FC<Props> = ({ topContent, children }) => (
  <Box>
    <Card margin="3rem 0" width="100%">
      {topContent}
    </Card>
    {children}
  </Box>
)

export { Details }
